/* eslint-disable no-console */

const shouldLog = process.env.NODE_ENV === 'development';
const noop = (): void => {};

export const log: typeof console.log = shouldLog ? console.log.bind(console) : noop;
export const warn: typeof console.warn = shouldLog ? console.warn.bind(console) : noop;
export const error: typeof console.error = shouldLog ? console.error.bind(console) : noop;
